import { gql } from '@apollo/client';

/**
 * A funder or service provider hanging off the portal organisation. Only the
 * identity and the profile logo are read here - the sidebar has no business
 * fetching the rest of an organisation's profile.
 */
export type PORTAL_ORGANISATION_ENTITYType = {
  id: string;
  logo: string | null;
} | null;

export type GET_PORTAL_ORGANISATIONType = {
  organisation: {
    id: string;
    modules: {
      id: string;
      name: string;
      editable: string;
    }[];
    funder?: PORTAL_ORGANISATION_ENTITYType;
    serviceProvider?: PORTAL_ORGANISATION_ENTITYType;
  } | null;
} | null;

export const GET_PORTAL_ORGANISATION = gql`
  query GetPortalOrganisation($portal: String!) {
    organisation: getPortalOrganisation(portal: $portal) {
      id
      modules {
        id
        name
        editable
      }
      funder {
        id
        logo
      }
      serviceProvider {
        id
        logo
      }
    }
  }
`;
